import { Col, Row } from "antd";
import { useField } from "formik";
import React from "react";
import { FormikInputParams } from "./FormikInputParams.model";

export interface EBTextInputV2Props extends FormikInputParams {
  prependNode?: React.ReactNode;
  appendNode?: React.ReactNode;
  className?: string;

  maxLength?: number;
  minLength?: number;
  showCount?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

export function EBTextInputV2(props: EBTextInputV2Props) {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and alse replace ErrorMessage entirely.
  const { onChange: onChangeProp, ...restProps } = props;
  const [field, meta] = useField(restProps);
  let fieldValue = field.value;

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    field.onChange(e);       // keep Formik state in sync
    onChangeProp?.(e);       // call the optional override (e.g. URL auto-detection)
  };

  return (
    <>
      {props.prependNode || props.appendNode ? (
        <div className="input-group">
          {props.prependNode}
          <input className="form-control" type="text" {...field} {...restProps} onChange={handleChange} />
          {props.appendNode}
        </div>
      ) : (
        <input
          className="form-control"
          type="text"
          {...field}
          {...restProps}
          maxLength={props.maxLength}
          minLength={props.minLength}
          onChange={handleChange}
        />
      )}

      <Row>
        <Col flex={"auto"}>
          {props.helpText ? (
            <small className="form-text text-muted">{props.helpText}</small>
          ) : null}
        </Col>
        <Col>
          {props.showCount && (
            <>
              <small className="form-text text-muted">
                {fieldValue ? fieldValue.toLocaleString().length : 0}
                {props.maxLength != undefined && `/${props.maxLength}`}
              </small>
            </>
          )}
        </Col>
      </Row>

      {meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : null}
    </>
  );
}
